import * as React from 'react';
import {fetchGrupoPlanes}from '../../actions/planesActions';
import { connect } from 'react-redux';

import { toast } from 'react-toastify';
import { postAdministracionTiposPublicacion,postTiposPublicacionAsociarGrupoPlanes } from '../../api/axios';
import { setTiposPublicacion,setTiposGrupoPlanes } from '../../actions/tiposPublicacionActions';
import TablaGrupoPlanes from './TablaGrupoPlanes';
import Cleave from 'cleave.js/react';

class TipoPublicacionesNew extends React.Component {
    constructor(props) {
        super(props);
        this.state={            
            // IdGrupoPlan:"",
            // planes: [],            
            // gruposDePlanes:[],        
            // grupoDePlanes:[
            //     { text: "Contado", value: 1 },
            //     { text: "6 cuotas", value: 2 },
            //     { text: "6 cuotas sin interes", value: 3 },
            //     { text: "12 cuotas", value: 4 },
            //     { text: "12 cuotas sin interes", value: 5 },                
            //     { text: "opcion 6", value: 6 },                
            //     { text: "opcion 7", value: 7 },                
            //     { text: "opcion 8", value: 8 },                
            // ]
            descripcion:"",
            comision:0,
            gruposDePlanes:[],            
        }

    };

    componentDidMount() {
        this.busquedaGrupoPlanes({numeroPagina:1,cantidadPagina:10});   
        this.setState({
            descripcion:this.props.setTipoPublicacion.descripcion,
            comision:this.props.setTipoPublicacion.comision
        })
    }

    changeCheck=(params)=>{
        this.addToPlanes(params);
    }

    clickFila=(params)=>{        
        this.addToPlanes(params);
    }

    addToPlanes=(params)=>{
        let arrayEstado = [];
        arrayEstado = this.state.gruposDePlanes;
        let repetido=arrayEstado.some(x => x == params.idGrupoPlan);
        
        if(repetido){
            let index = arrayEstado.findIndex(x=>x==params.idGrupoPlan);            
            if (index !== undefined){
                arrayEstado.splice(index, 1);                
                this.setState({gruposDePlanes:arrayEstado});
                document.getElementById("check" + params.idGrupoPlan).checked = false;                
            }            
        }
        else{
            arrayEstado.push(params.idGrupoPlan);
            this.setState({gruposDePlanes:arrayEstado});
            document.getElementById("check" + params.idGrupoPlan).checked = true;            
        }
    }

    busquedaGrupoPlanes=(request)=>{
        let params=request;
        let idSeller=this.props.seller;
        //si es seller

        if (this.props.tipoUsuario !== 2){
            params={...request,idSeller:idSeller};
            this.props.fetchGrupoPlanes({params});
        }else{
            this.props.fetchGrupoPlanes({params});
        }
    }

    onSubmit = async (event) => {        
        event.preventDefault();
        let data={
            descripcion:this.props.setTipoPublicacion.descripcion,
            comision:parseFloat(this.props.setTipoPublicacion.comision)
        }
        if(Object.keys(this.props.setTipoPublicacion).length==1 || this.props.setTipoPublicacion.descripcion=="" || this.props.setTipoPublicacion.comision=="" || JSON.stringify(this.props.setTipoPublicacion)=="{}"){
            if(JSON.stringify(this.props.setTipoPublicacion)=="{}" || Object.keys(this.props.setTipoPublicacion).length==1){
                toast.error("Debe agregar una descripción");
                toast.error("Debe agregar una comisión");
            }
            if(this.props.setTipoPublicacion.descripcion==""){
                toast.error("Debe agregar una descripción");
            }
            if(this.props.setTipoPublicacion.comision==""){
                toast.error("Debe agregar una comisión");
            }
            return;
        }

        let postTipo = postAdministracionTiposPublicacion(data);

        postTipo.then(res => {
            toast.success("Tipo publicacion guardada");
            this.asociarGrupoPlanes(res.data.idTipoPublicacion);
            this.return();
          }).catch(err => {        
              toast.error("No pudo crearse");
            // (err.response.data.errores) ? err.response.data.errores.forEach(error => toast.error(error)) : toast.error("No pudo crearse");
          });
          
    }

    asociarGrupoPlanes=(id)=>{
        let elementIdGrupo=null;
        let arrayIdsElement=[];
        for (let index = 0; index < this.props.tiposGruposPlanes.length; index++) {
            elementIdGrupo = this.props.tiposGruposPlanes[index].idGrupoPlan;
            arrayIdsElement.push(elementIdGrupo);
        }
        let data={
            idTipoPublicacion:id,
            listaIdsGrupoPlanes:arrayIdsElement
        }
        
        let asociarGrupoPlanes=postTiposPublicacionAsociarGrupoPlanes(data)
        asociarGrupoPlanes.then(res=>{
            toast.success("Se asociaron grupos de planes");
        }).catch(err=>{
            // toast.error("No se seleccionaron grupos de planes")
        });
    }
    
    // inputChange = (e) => {
    //     let valor=e.target.value;
    //     this.setState({
    //         [e.target.name]: valor
    //     })
    // }

    inputChange = (e) => {
        var numbersOnly=/^[0-9.]+$/;
        let valor=e.target.value;

        if(e.target.name=="comision"){
            let esNumero=valor.match(numbersOnly);
            if(esNumero==null){
                document.getElementById("comisionId").value="";
                return;
            }
            if (e.target.value > 100) {
                document.getElementById("comisionId").value="";
            }else{
                let estado={...this.props.setTipoPublicacion,[e.target.name]:valor}
                this.props.setTiposPublicacion(estado);        
            }
        }else{
            let estado={...this.props.setTipoPublicacion,[e.target.name]:valor}
            this.props.setTiposPublicacion(estado);
        }        
    }


    
    goToBusqueda=()=>{
        this.props.history.push("/Tipo/Publicaciones/GrupoPlanes/Busqueda");
      }

    return = () => {
        this.props.history.push("/Tipo/Publicaciones");
    }

    borrarFila = (idGrupoPlan) => {
        let grupoPlanes = JSON.stringify(this.props.tiposGruposPlanes);
        if (grupoPlanes != "[]") {
            let index = this.props.tiposGruposPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
            this.props.tiposGruposPlanes.splice(index, 1);
            this.props.setTiposGrupoPlanes(this.props.tiposGruposPlanes);
            this.forceUpdate();
        }
    
    }

    tablaGrupos=()=>{
        
        
        let jsonData=JSON.stringify(this.props.tiposGruposPlanes)
        
        if (jsonData != "[]" && jsonData!=undefined) {
            var rows = [];
            let htmlData;
            this.props.tiposGruposPlanes.map((item) => {
                htmlData=<tr className="hover-background-color">
                    <td class="div-center">{item.idGrupoPlan}</td>
                    <td>{item.descripcion}</td>
                    <td class="div-center"><small className=" font-14  applyFont">{item.comision}<i className="fas fa-percent"></i></small></td>                    
                    <td onClick={() => this.borrarFila(item.idGrupoPlan)}><i class="fas fa-trash-alt"></i></td>
                </tr>
                rows.push(htmlData);
            });
            return rows;
        }

    }



    render() {
        let descripcion;
        let comision;
        if (this.state.cambioInputChange == false) {
            descripcion = this.props.setTipoPublicacion.descripcion != undefined ? this.props.setTipoPublicacion.descripcion : this.props.tipoPublicacion.descripcion;
            comision = this.props.setTipoPublicacion.comision != undefined ? this.props.setTipoPublicacion.comision : this.props.tipoPublicacion.comision;
        } else {
            comision = this.state.comisionPredeterminada;
        }

        return (

            <div className="col-sm-12">

                <div className="card">
                    <div className="card-body p-b-0">
                        <h4 className="card-title">Tipo de publicaciones</h4>
                        <form className="form-horizontal form-material   p-10" >
                            <div className="tab-content">

                            <div className="button-group align-self-center text-right d-none d-md-block">
                                
                                <button type="button" onClick={this.goToBusqueda} className="btn btn-sm background-rojo-megatone m-r-10"><i className="fa fa-plus-circle"></i>Seleccionar grupos</button>
                                
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label className="label-oscura">Descripción</label>
                                        <input name="descripcion" value={descripcion} onKeyUp={this.inputChange} type="text" id="firstName" class="form-control"></input>
                                    </div>
                                    <div class="col-md-6">
                                    <small className=" font-14  applyFont"><i className="fas fa-percent"></i></small>
                                        <label className="label-oscura">&ensp;Comisión</label>
                                        {/* <input name="comision" value={this.state.comision} onKeyUp={this.inputChange} type="number" className="form-control" /> */}
                                            <Cleave id="comisionId" name="comision" value={this.props.setTipoPublicacion.comision == 100 ? 100 : this.props.setTipoPublicacion.comision} onKeyUp={this.inputChange} className="form-control"
                                            options={{ blocks: [5], numericOnly: false }}/>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        {/* <TablaGrupoPlanes></TablaGrupoPlanes> */}

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="div-center">ID</th>
                                        <th>Descripción</th>
                                        <th class="div-center">Comisión</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.tablaGrupos()
                                    }
                                </tbody>
                            </table>

         
                        <div>
                                <button onClick={this.onSubmit} className="btn  btn-sm background-rojo-megatone waves-light m-r-10">Guardar</button>
                                <button onClick={this.return} class="btn btn-sm btn-light waves-effect waves-light">Salir</button>
                            </div>
                        </form>

                    </div>

            </div>
                    
                    
            </div>




        );
    }

}


const mapStateToProps = state => (
    {
        editando:state.general.editando,
        tipoUsuario: state.general.tipoUsuario,
        seller: state.general.idSeller,        
        grupoPlanes:state.planes.grupoPlanes.elementos,
        grupoPlanesDesdeBusqueda: state.planes.grupoPlanesBusqueda,
        setTipoPublicacion:state.tiposPublicacion.setTiposPublicacion,
        tiposGruposPlanes:state.tiposPublicacion.tiposGruposPlanes,
        
    });
export default connect(mapStateToProps, { fetchGrupoPlanes,setTiposPublicacion,setTiposGrupoPlanes })(TipoPublicacionesNew); 